<template>
  <form class=" mt-2 row g-3 align-items-baseline" v-if="model">
    <div class="form-group col-md-12 text-end">
      <i v-if="esPersonaJuridica" class="fa-sharp fa-light fa-lg fa-building text-success"></i>
      <i v-if="esPersonaFisica" class="fa-sharp fa-light fa-lg fa-person text-success"></i>
      <span class="ms-2 text-primary">{{ model?.Titular.TipoPersona == TipoPersonaEnum.Fisica ? $t('operaciones.form.persona_física') :
        $t('operaciones.form.persona_jurídica') }}</span>
    </div>
    <template v-if="esPersonaJuridica">
      <div class="form-group col-md-6">
        <label class="dx-field-item-label-text" for="inputNombreRazon">{{
          $t('operaciones.form.nombre_razon_social') }}</label>
        <div class="mt-1" id="inputNombreRazon">{{ model?.Titular.RazonSocial }}</div>
      </div>
      <div class="form-group col-md-3">
        <label class="dx-field-item-label-text" for="inputCIF">{{ $t('operaciones.form.cif') }}</label>
        <div class="mt-1" id="inputCIF">{{ model?.Titular.CIF }}</div>
      </div>
      <div class="form-group col-md-3">
        <label class="dx-field-item-label-text" for="inputSubtipoPersona">{{ $t('subtipo_persona.label') }}</label>
        <div class="mt-1" id="inputSubtipoPersona">{{ model?.Titular.SubtipoPersona ? $t(`subtipo_persona.values.${model?.Titular.SubtipoPersona}`) : '' }}</div>
      </div>
      <template v-if="esComunidadPropietarios">
        <div class="form-group col-md-3">
          <label class="dx-field-item-label-text" for="inputIdTipoRepresentanteCcpp">{{ $t('operaciones.form.tipo_representante_ccpp') }}</label>
          <div class="mt-1" id="inputIdTipoRepresentanteCcpp">{{ model?.Titular.IdTipoRepresentanteCcPp ? $t(`shared.enums.tipo_representante_ccpp.${model?.Titular.IdTipoRepresentanteCcPp}`) : '' }}</div>
        </div>
        <div v-if="model?.Titular.IdTipoRepresentanteCcPp == TipoRepresentanteCcppEnum.AdministradorFincas" class="form-group col-md-3">
          <label class="dx-field-item-label-text" for="inputNumeroColegiadoAdministradorFincas">{{ $t('operaciones.form.numero_colegiado_administrador_fincas') }}</label>
          <div class="mt-1" id="inputNumeroColegiadoAdministradorFincas">{{ model?.Titular.NumeroColegiadoAdministradorFincas }}</div>
        </div>
        <div v-if="model?.Titular.IdTipoRepresentanteCcPp == TipoRepresentanteCcppEnum.AdministradorFincas" class="form-group col-md-3">
          <label class="dx-field-item-label-text" for="inputColegioAdministradorFincas">{{ $t('operaciones.form.colegio_administrador_fincas') }}</label>
          <div class="mt-1" id="inputColegioAdministradorFincas">{{ model?.Titular.ColegioAdministradorFincas }}</div>
        </div>
      </template>
      <div>
        <span class="dx-field-item-label-text text-success">{{ $t('operaciones.form.responsable_autorizado') }}</span>
      </div>
    </template>
    <div class="form-group col-md-4">
      <label class="dx-field-item-label-text" for="inputNombre">{{ $t('operaciones.form.nombre') }}</label>
      <div class="mt-1" id="inputNombre">{{ model?.Titular.Nombre }}</div>
    </div>
    <div class="form-group col-md-4">
      <label class="dx-field-item-label-text" for="inputApellidos">{{ $t('operaciones.form.apellidos') }}</label>
      <div class="mt-1" id="inputApellidos">{{ model?.Titular.Apellidos }}</div>
    </div>
    <div class="form-group col-md-4">
      <label class="dx-field-item-label-text" for="inputNacionalidad">{{ $t('operaciones.form.nacionalidad') }}</label>
      <div class="mt-1" id="inputNacionalidad">{{ model?.Titular.Nacionalidad }}</div>
    </div>
    <div class="form-group col-md-4">
      <label class="dx-field-item-label-text" for="inputDNI">{{ $t('operaciones.form.dni') }}</label>
      <div class="mt-1" id="inputDNI">{{ model?.Titular.Documento }}</div>
    </div>
    <div class="form-group col-md-2">
      <label class="dx-field-item-label-text" for="inputTelefonoMovil">{{ $t('operaciones.form.telefono_movil') }}</label>
      <div class="mt-1" id="inputTelefonoMovil">{{ model?.Titular.Movil }}</div>
    </div>
    <div class="form-group col-md-2">
      <label class="dx-field-item-label-text" for="inputTelefonoFijo">{{ $t('operaciones.form.telefono_fijo') }}</label>
      <div class="mt-1" id="inputTelefonoFijo">{{ model?.Titular.Telefono }}</div>
    </div>
    <div class="form-group col-md-4">
      <label class="dx-field-item-label-text" for="inputEmail">{{ $t('operaciones.form.email') }}</label>
      <div class="mt-1" id="inputEmail">{{ model?.Titular.Email }}</div>
    </div>
    <div class="col-12">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="inputCheckAutorizacion"
          :checked="model?.Titular.CambioTitular" disabled>
        <span class="form-check-label " for="inputCheckAutorizacion">
          {{ $t('operaciones.form.cambio_titular_texto') }}
        </span>
      </div>
    </div>
  </form>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { type DetailOperacionEnergiaModel, SubtipoPersonaEnum, TipoPersonaEnum, TipoRepresentanteCcppEnum, TipoSuministroTramiteEnergiaEnum } from '@/.shared/.api';
import { useIntl } from '@/.shared/services/i18n/i18nservice';

const intl = useIntl();

const props = defineProps({
  model: Object as () => DetailOperacionEnergiaModel,
  tramite: String as () => TipoSuministroTramiteEnergiaEnum
});

const esPersonaJuridica = computed(() => {
  return props.model?.Titular.TipoPersona == TipoPersonaEnum.Juridica;
});

const esPersonaFisica = computed(() => {
  return props.model?.Titular.TipoPersona == TipoPersonaEnum.Fisica;
});

const esComunidadPropietarios = computed(() => {
  return props.model?.Titular.SubtipoPersona == SubtipoPersonaEnum.Ccpp;
});

</script>

<style lang="scss" scoped>

@import "@styles/_sharedvars.scss";

div[id^="input"] {
  border-bottom: 1px solid var(--border-default-default);
  padding: 5px 12px;
  background: var(--background-normal-light);
  color: var(--text-default-caption);
  height: 30px;
}

.dx-field-item-label-text {
  white-space: nowrap;
  word-wrap: normal;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>